import { useState, useEffect } from "react";
import {
  Divider,
  Typography,
  Drawer,
  Dropdown,
  Menu,
  Form,
  Input,
  Button,
  Checkbox,
  Tabs,
} from "antd";
import Slider from "react-slick";
import {
  EnvironmentOutlined,
  DownOutlined,
  MenuOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  HomeFilled,
  TableOutlined,
  GiftOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";
import "./index.css";
import { mstGeneral } from "../../mobx";
import { observer } from "mobx-react-lite";
import { getSnapshot } from "mobx-state-tree";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useCart } from "../cart/CartContext";
import { useAuth } from "../auth/AuthContext";
import RoomBookingList from "../../pages/modules/Room/RoomBookingList";
import TableBookingList from "../../pages/modules/Table/TableBookingList";
import VoucherBookingList from "../../pages/modules/Voucher/VoucherBookingList";
import ProductBookingList from "../../pages/modules/Product/ProductBookingList";
import { useReferral } from "../../utils/referral";

const { Text, Link, Title } = Typography;
const { TabPane } = Tabs;

const BookingMenuSelection = observer((props: any) => {
  const location = useLocation();
  const { hideBanner } = props;
  const { isLoggedIn, onOpenLoginModal, logout, user } = useAuth();
  const { navigateWithReferral } = useReferral();
  const { showCart } = useCart();
  const [visible, setVisible] = useState(false);
  const [imageSlides, setImageSlides] = useState([]);
  const [loggingIn, setLoggingIn] = useState(false);
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("room");
  const { moduleName } = useParams();

  useEffect(() => {
    if (moduleName) {
      setSelectedMenu(moduleName);
    }
  }, [moduleName]);

  useEffect(() => {
    mstGeneral.fetchCompanyDetails();
    mstGeneral
      .fetchImageSlides()
      .then((response) => {
        setImageSlides(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const onLogin = () => {
    setLoggingIn(true);
    setTimeout(() => {
      setLoggingIn(false);
    }, 5000);
  };

  const toggleDrawer = () => {
    setVisible(!visible);
  };

  const handleTabChange = (key: string) => {
    setSelectedMenu(key);
    // Update URL without page reload
    navigateWithReferral(`/bookings/${key}`, { replace: true });
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <a target="_self" href="/bookings">
          Bookings
        </a>
      </Menu.Item>
      <Menu.Item>
        <a target="_self" href="/profile/edit">
          Edit Profile
        </a>
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          logout();
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <div>
      <div>
        {/* Tab Navigation */}
        <div>
          <Tabs
            activeKey={selectedMenu}
            onChange={handleTabChange}
            type="card"
            // className="booking-tabs"
            size="large"
          >
            <TabPane
              tab={
                <span>
                  <HomeOutlined
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                  Room
                </span>
              }
              key="room"
            >
              <RoomBookingList />
            </TabPane>

            {/* <TabPane
              tab={
                <span>
                  <TableOutlined
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                  Table
                </span>
              }
              key="table"
            >
              <TableBookingList />
            </TabPane>

            <TabPane
              tab={
                <span>
                  <GiftOutlined
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                  Vouchers
                </span>
              }
              key="voucher"
            >
              <VoucherBookingList />
            </TabPane>

            <TabPane
              tab={
                <span>
                  <ShoppingOutlined
                    onPointerEnterCapture={undefined}
                    onPointerLeaveCapture={undefined}
                  />
                  Products
                </span>
              }
              key="product"
            >
              <ProductBookingList />
            </TabPane> */}
          </Tabs>
        </div>
      </div>
    </div>
  );
});

export default BookingMenuSelection;
